export default __webpack_public_path__ + "static/media/barak-6.d151b7e1.jpeg";